import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, ControlLabel, Alert } from "react-bootstrap";
import { authOperations } from './state';
import { withRouter } from "react-router-dom";
import logo from '../../../includes/img/logo.gif';
import { AZ_az_09, MIN_LOGIN_CHAR, EMPTY_STRING } from '../../../utils/constants';
import '../../../includes/custom/css/login.css';
import { ERROR_INVALID_USERNAME_PAS } from "../../../utils/messages";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm() {
    return MIN_LOGIN_CHAR < this.state.username.length && MIN_LOGIN_CHAR < this.state.password.length;
  }

  handleChange = (event) => {
    if (event.target.value.match(AZ_az_09) || EMPTY_STRING === event.target.value) {
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();    
    if (this.validateForm) {
      this.setState({ error: false });
      this.props.loginUser(this.state.username, this.state.password)
        .catch((e) => {
          JSON.parse(JSON.stringify(e)).response ?
           this.setState({ error: ERROR_INVALID_USERNAME_PAS }):
           this.setState({ error: "NETWORK_ERR" });
        });
    } else {
      this.setState({ error: ERROR_INVALID_USERNAME_PAS });
    }

  }

  render() {
    const minLength = 8;
    const maxLength = 16;

    return (
      <div>
        <img src={logo} className="App-logo" alt="logo" />
        <form onSubmit={this.handleSubmit}>
            {
              this.state.error && EMPTY_STRING !== this.state.error
              && <Alert bsStyle="danger" className="pre-wrap">{this.state.error}</Alert>
            }
          <div className="loginForm">
           
            <Row>
              <span><ControlLabel>ログインID:</ControlLabel></span>
              <span>
                <input
                  name="username"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.username}
                  minLength={minLength}
                  maxLength={maxLength} />
              </span>
            </Row>
            <Row>
              <span><ControlLabel>パスワード:</ControlLabel></span>
              <span>
                <input
                  name="password"
                  type="password"
                  onChange={this.handleChange}
                  value={this.state.password}
                  minLength={minLength}
                  maxLength={maxLength} />
              </span>
            </Row>
          </div>
          <br />
          <center>
            <p><b><a className="loginLink" onClick={() => this.props.toggleLogin()}>パスワード変更はこちら</a></b></p><br />
            <button
              className="loginButton"
              onClick={this.handleSubmit}
              type="submit"
            >
              ログイン
            </button>
            <br />
          </center>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
  }
};

const mapDispatchToProps = {
  loginUser: authOperations.loginUser,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));